import { render, staticRenderFns } from "./MonitorsList.vue?vue&type=template&id=58cf3180"
import script from "./MonitorsList.vue?vue&type=script&lang=js"
export * from "./MonitorsList.vue?vue&type=script&lang=js"
import style0 from "./MonitorsList.vue?vue&type=style&index=0&id=58cf3180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports